import React from "react";
import MainLayout from "../../../hoc/main";
import {Grid, TableData} from "../../../components";
import {connect} from "react-redux";
import {
    getDeletedAcBrandDatas,
    hardDeleteAcBrandData,
    restoreAcBrandData,
} from "../../../redux/modules/AcBrand/action";

class AcBrandTrash extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            datas: [],
        };
    }

    componentDidMount() {
        this.props.getDeletedAcBrandDatas();
    }

    UNSAFE_componentWillReceiveProps(np) {
        this.setState({
            datas: np.acBrand.datas,
        });
    }

    render() {
        // console.log(this.state.datas);
        const acBrandColumn = [
            {
                name: "Access Brand",
                path: "name",
                show: true,
            },
        ];

        return (
            <div className="p-6 mt-20 xl:mt-0 ">
                <Grid>
                    <TableData
                        path={this.props.location.pathname}
                        title={"Access Brand Data"}
                        data={this.props.acBrand.datas}
                        columns={acBrandColumn}
                        trashAction={true}
                        deleteAction={(id) => this.props.hardDeleteAcBrandData(id)}
                        restoreAction={(id) => this.props.restoreAcBrandData(id)}
                    />
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    acBrand: state.acBrand,
});

const mapDispatchToProps = {
    getDeletedAcBrandDatas,
    hardDeleteAcBrandData,
    restoreAcBrandData,
};

export default MainLayout(
    connect(mapStateToProps, mapDispatchToProps)(AcBrandTrash)
);
